import { BasicProps } from "components/types/BasicProps";
import { FC, useState } from "react";
import { FilterOption, FilterPossibleValue } from "./Filter";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import classNames from "classnames";
import { FaChevronUp } from "react-icons/fa";

type Props = BasicProps & { option: FilterOption };

const FilterRadio: FC<Props> = (props) => {
  const { option, className } = props;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const [isOptionOpen, setOptionOpen] = useState<boolean>(false);

  const paramValue = searchParams.get(option.name);

  const handleInputClick = (filterValue: FilterPossibleValue) => {
    const params = new URLSearchParams(searchParams.toString());

    if (filterValue.name === "all") {
      params.delete(option.name);
    } else {
      params.set(option.name, filterValue.name);
    }

    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  const handleFilterClick = () => setOptionOpen(!isOptionOpen);

  return (
    <li className={classNames("flex flex-col gap-4", className)}>
      <div
        onClick={handleFilterClick}
        className="pb-2.5 border-b border-b-white flex justify-between items-center"
      >
        <h4 className="text-base font-normal">{option.label}</h4>
        <FaChevronUp
          className={classNames(
            "transition-transform duration-200 transform",
            isOptionOpen ? "rotate-180" : "rotate-0"
          )}
          width={7}
          height={7}
        />
      </div>

      <ul className="flex flex-col gap-4">
        {isOptionOpen &&
          option.values.map((value) => {
            const isChecked =
              (!paramValue && value.name === "all") ||
              paramValue === value.name;

            return (
              <div
                key={value.name}
                className="flex items-center mb-4 cursor-pointer"
              >
                <input
                  className="w-4 h-4 text-primary border border-white rounded-full checked:bg-primary cursor-pointer"
                  id={value.name}
                  type="radio"
                  value={value.name}
                  checked={isChecked}
                  name={option.name}
                  onChange={() => handleInputClick(value)}
                />
                <label
                  htmlFor={value.name}
                  className="ml-2 text-sm font-medium cursor-pointer"
                >
                  {value.label}
                </label>
              </div>
            );
          })}
      </ul>
    </li>
  );
};

export default FilterRadio;
